<div>
    <ng-container *ngIf="!ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent" style="width: 100%;">
            <mat-select [formControl]="ngControl.control" [multiple]="multiple" [placeholder]="placeholder" [disabled]="readonly">
                <input *ngIf="filterEnabled" #selectFilterInput
                    placeholder="{{'INPUT.SELECT-FILTER' | translate}}" 
                    class="select-filter" 
                    (keydown)="$event.stopPropagation()"
                    (keyup)="onFilterSelectKeyUp($event)">
                <mat-option *ngIf="allOptionEnabled">{{'PLACEHOLDER.ALL' | translate}}
                </mat-option>
                <mat-option *ngFor="let item of filteredItemsData"
                    [value]="item.id">
                    {{item.description | translate}}
                </mat-option>
                </mat-select>             
        </mat-form-field> 
        <!-- errors -->
        <ng-container *ngIf="ngControl.control.touched">
            <mat-error *ngIf="ngControl.control.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
        </ng-container> 
    </ng-container>

    <ng-container *ngIf="ngControl.control.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <p *ngIf="!multiple; else detailMultipleMode" style="font-weight: bold;">{{filteredItemsData|getById:ngControl.value:'description'}}</p>
        <ng-template #detailMultipleMode>
            <p *ngFor="let item of $any(value)" style="font-weight: bold;">
                {{filteredItemsData|getById:item:'description'}}
            </p>
        </ng-template>
    </ng-container>
</div>
